const kashika5Options = [

    {
        menuName: "地域の利便性（周辺環境・施設）",
        activateAccordion: false,
        useAccordion: true,
        layerOrderList : [
            {
                type: "element",
                id: "vis_98_1",
            },
            {
                type: "element",
                id: "vis_98_2",
            },
            {
                type: "list",
                subLayerId: "vis_98_3",
                subLayerName: "学校",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_98_3",
                    },
                    {
                        type: "element",
                        id: "vis_98_4",
                    },
                    {
                        type: "element",
                        id: "vis_98_5",
                    },
                    {
                        type: "element",
                        id: "vis_98_6",
                    },
                    {
                        type: "element",
                        id: "vis_98_7",
                    },
                    {
                        type: "element",
                        id: "vis_98_8",
                    },
                    {
                        type: "element",
                        id: "vis_98_9",
                    },
                    {
                        type: "element",
                        id: "vis_98_10",
                    },
                    {
                        type: "element",
                        id: "vis_98_11",
                    },
                    {
                        type: "element",
                        id: "vis_98_12",
                    },
                    {
                        type: "element",
                        id: "vis_98_13",
                    }
                ],
            },
            {
                type: "list",
                subLayerId: "vis_98_14",
                subLayerName: "保育園・幼稚園",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_98_14",
                    },
                    {
                        type: "element",
                        id: "vis_98_15",
                    },
                    {
                        type: "element",
                        id: "vis_98_16",
                    },
                    {
                        type: "element",
                        id: "vis_98_17",
                    },
                    {
                        type: "element",
                        id: "vis_98_18",
                    }
                ],
            },
            {
                type: "list",
                subLayerId: "vis_98_19",
                subLayerName: "医療機関",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_98_19",
                    },
                    {
                        type: "element",
                        id: "vis_98_20",
                    },
                    {
                        type: "element",
                        id: "vis_98_21",
                    }
                ]
            },
            {
                type: "list",
                subLayerId: "vis_98_22",
                subLayerName: "福祉施設",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_98_22",
                    },
                    {
                        type: "element",
                        id: "vis_98_23",
                    },
                    {
                        type: "element",
                        id: "vis_98_24",
                    },
                    {
                        type: "element",
                        id: "vis_98_25",
                    },
                    {
                        type: "element",
                        id: "vis_98_26",
                    },
                    {
                        type: "element",
                        id: "vis_98_27",
                    },
                    {
                        type: "element",
                        id: "vis_98_28",
                    }
                ]
            },
            {
                type: "list",
                subLayerId: "vis_98_29",
                subLayerName: "図書館",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_98_29",
                    }
                ]
            },
            {
                type: "list",
                subLayerId: "vis_98_30",
                subLayerName: "役場・集会施設",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_98_30",
                    },
                    {
                        type: "element",
                        id: "vis_98_31",
                    }
                ]
            },
            {
                type: "list",
                subLayerId: "vis_98_32",
                subLayerName: "駅",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_98_32",
                    },
                    {
                        type: "element",
                        id: "vis_98_33",
                    },
                    {
                        type: "element",
                        id: "vis_98_34",
                    }
                ]
            },
            {
                type: "element",
                id: "vis_95_1",
            },
            {
                type: "element",
                id: "vis_95_2",
            },
            {
                type: "element",
                id: "vis_95_3",
            },
        ],
        options: [
            {
                id: "vis_98_1",
                label: "小学校区",
                fetchedServerKey: "XKT004",
                type: "vector",
                url:process.env.REACT_APP_TILE_XKT004,
                layerName:"hits",
                color:"#2121e0",
                backgroundColor:"transparent",
                legendColorClass: "h-vis_98_1",
                opacity: 0.7,
            },
            {
                id: "vis_98_2",
                label: "中学校区",
                fetchedServerKey: "XKT005",
                type: "vector",
                url:process.env.REACT_APP_TILE_XKT005,
                layerName:"hits",
                color:"#ff0000",
                backgroundColor:"transparent",
                legendColorClass: "h-vis_98_2",
                opacity: 0.7,
            },
            {
                id: "vis_98_3",
                label: "小学校",
                type: "geojson",
                fetchedServerKey: "XKT006",
                targetCode: "16001",
            },


            {
                id: "vis_98_4",
                label: "中学校",
                type: "geojson",
                fetchedServerKey: "XKT006",
                targetCode: "16002",
            },

            {
                id: "vis_98_5",
                label: "中等教育学校",
                type: "geojson",
                fetchedServerKey: "XKT006",
                targetCode: "16003",
            },

            {
                id: "vis_98_6",
                label: "高等学校",
                type: "geojson",
                fetchedServerKey: "XKT006",
                targetCode: "16004",
            },

            {
                id: "vis_98_7",
                label: "高等専門学校",
                type: "geojson",
                fetchedServerKey: "XKT006",
                targetCode: "16005",
            },

            {
                id: "vis_98_8",
                label: "短期大学",
                type: "geojson",
                fetchedServerKey: "XKT006",
                targetCode: "16006",
            },

            {
                id: "vis_98_9",
                label: "大学",
                type: "geojson",
                fetchedServerKey: "XKT006",
                targetCode: "16007",
            },

            {
                id: "vis_98_10",
                label: "特別支援学校",
                type: "geojson",
                fetchedServerKey: "XKT006",
                targetCode: "16012",
            },

            {
                id: "vis_98_11",
                label: "義務教育学校",
                type: "geojson",
                fetchedServerKey: "XKT006",
                targetCode: "16014",
            },

            {
                id: "vis_98_12",
                label: "各種学校",
                type: "geojson",
                fetchedServerKey: "XKT006",
                targetCode: "16015",
            },

            {
                id: "vis_98_13",
                label: "専修学校",
                type: "geojson",
                fetchedServerKey: "XKT006",
                targetCode: "16016",
            },

            {
                id: "vis_98_14",
                label: "幼稚園",
                type: "geojson",
                fetchedServerKey: "XKT007",
                targetCode: "16011",
            },

            {
                id: "vis_98_15",
                label: "幼保連携型認定こども園",
                type: "geojson",
                fetchedServerKey: "XKT007",
                targetCode: "16013",
            },

            {
                id: "vis_98_16",
                label: "保育所等",
                type: "geojson",
                fetchedServerKey: "XKT007",
                targetCode: "0504",
            },

            {
                id: "vis_98_17",    
                label: "地域型保育事業所",
                type: "geojson",
                fetchedServerKey: "XKT007",
                targetCode: "0505",
            },

            {
                id: "vis_98_18",
                label: "認可外保育施設",
                type: "geojson",
                fetchedServerKey: "XKT007",
                targetCode: "0506",
            },

            {
                id: "vis_98_19",
                label: "病院",
                type: "geojson",
                fetchedServerKey: "XKT010",
                targetCode: "1",
            },

            {
                id: "vis_98_20",
                label: "診療所",
                type: "geojson",
                fetchedServerKey: "XKT010",
                targetCode: "2",
            },

            {
                id: "vis_98_21",
                label: "歯科診療所",
                type: "geojson",
                fetchedServerKey: "XKT010",
                targetCode: "3",
            },

            {   
                id: "vis_98_22",
                label: "保護施設",
                type: "geojson",
                fetchedServerKey: "XKT011",
                targetCode: "01",
            },

            {
                id: "vis_98_23",
                label: "老人福祉施設",
                type: "geojson",
                fetchedServerKey: "XKT011",
                targetCode: "02",
            },

            {
                id: "vis_98_24",
                label: "障害者支援施設等",
                type: "geojson",
                fetchedServerKey: "XKT011",
                targetCode: "03",
            },

            {
                id: "vis_98_25",
                label: "身体障害者社会参加支援施設",
                type: "geojson",
                fetchedServerKey: "XKT011",
                targetCode: "04",
            },

            {
                id: "vis_98_26",
                label: "児童福祉施設等",
                type: "geojson",
                fetchedServerKey: "XKT011",
                targetCode: "05",
            },

            {   
                id: "vis_98_27",
                label: "母子・父子福祉施設",
                type: "geojson",
                fetchedServerKey: "XKT011",
                targetCode: "06",
            },

            {
                id: "vis_98_28",
                label: "その他の社会福祉施設等",
                type: "geojson",
                fetchedServerKey: "XKT011",
                targetCode: "99",
            },

            {
                id: "vis_98_29",
                label: "図書館",
                type: "geojson",
                fetchedServerKey: "XKT017",
                targetCode: "3003",
            },

            {
                id: "vis_98_30",
                label: "役場・出張所",
                type: "geojson",
                fetchedServerKey: "XKT018",
                targetCode: "type1",
            },

            {
                id: "vis_98_31",
                label: "公民館・集会施設",
                type: "geojson",
                fetchedServerKey: "XKT018",
                targetCode: "type2",
            },

            {   
                id: "vis_98_32",
                label: "JR新幹線",
                type: "geojson",
                fetchedServerKey: "XKT015",
                targetCode: "1",
            },

            {   
                id: "vis_98_33",
                label: "JR在来線",
                type: "geojson",
                fetchedServerKey: "XKT015",
                targetCode: "2",
            },

            {
                id: "vis_98_34",
                label: "その他",
                type: "geojson",
                fetchedServerKey: "XKT015",
                targetCode: "others",
            },

            {
                id: "vis_98_35",
                label: "不動産取引価格情報・成約価格情報",
                type: "geojson",
                fetchedServerKey: "XPT001",
                targetCode: "",
            },

            {
                label: "徒歩圏内の施設充実度(点)",
                type: "vector",
                id: "vis_95_1",
                url:process.env.REACT_APP_LAYER_95_1,
                layerName:"95_1_real_estate_chart",
                color:"#6373e6",
                opacity: 0.7,
            },
            {
                label: "徒歩圏内の高低差(m)",
                type: "vector",
                id: "vis_95_2",
                url:process.env.REACT_APP_LAYER_95_2,
                layerName:"95_1_real_estate_chart",
                color:"#6373e6",
                opacity: 0.7,
            },
            {
                label: "徒歩圏内の緑の割合(%)",
                type: "vector",
                id: "vis_95_3",
                url:process.env.REACT_APP_LAYER_95_3,
                layerName:"95_1_real_estate_chart",
                color:"#6373e6",
                opacity: 0.7,
            },
        ]
    },

    {
        menuName: "地域の安全性（災害リスク）",
        activateAccordion: false,
        useAccordion: true,
        layerOrderList : [
            {
                type: "element",
                id: "kasen-saidai",
            },
            {
                type: "element",
                id: "takashio-saidai",
            },
            {
                type: "element",
                id: "tsunami-saigai",
            },
            {
                type: "element",
                id: "tosha_73_1",
            },
            {
                type: "element",
                id: "tosha_73_2",
            },
            {
                type: "element",
                id: "tosha_73_4",
            },
            {
                type: "element",
                id: "73_kyukeisya_tokubetsukeikai",
            },
            {
                type: "element",
                id: "tosha_73_3",
            },
        ],
        options: [
            {
                label : "河川浸水想定区域図\n（想定最大規模）",
                type: "vector",
                id: "kasen-saidai",
                url:process.env.REACT_APP_LAYER_64_2_KASEN_SHINSUI_MAX,
                layerName:"64_2_shinsui_souteisaidai",
                color:"orangered",
                opacity: 0.7
            },
            {
                label: "高潮浸水想定図\n（想定最大規模）",
                type: "vector",
                id: "takashio-saidai",
                url:process.env.REACT_APP_LAYER_70_3_TAKASHIO_KEIKAKU,
                layerName:"70_3_takashio_max",
                color:"steelblue",
                opacity: 0.7
            },
            {
                label: "津波災害警戒区域図",
                type: "vector",
                id: "tsunami-saigai",
                url:process.env.REACT_APP_TSUNAMI_SAIGAI,
                layerName:"72_tsunami_keikai",
                color:"#ffffb3",
                opacity: 0.7,
                legendColorClass: "h-tsunami-saigai",
            },
            {
                label: "土砂災害警戒区域（土石流）",
                type: "vector",
                id: "tosha_73_1",
                url:process.env.REACT_APP_LAYER_73_1,
                layerName: "73_dosekiryu_keikai",
                color:"#fffe9b",
                borderColor:"#1072bd",
                border: '1px solid blue',
                opacity: 0.7,
                legendColorClass: "h-dosha-dsk-dosekiryu"
            },

            {
                label: "土砂災害特別警戒区域（土石流）",
                type: "vector",
                id: "tosha_73_2",
                url:process.env.REACT_APP_LAYER_73_2,
                layerName: "73_dosekiryu_tokubetsukeikai",
                color:"#fe868d",
                borderColor:"#fc0d1b",
                opacity: 0.7,
                legendColorClass: "h-dosha-dstk-dosekiryu"
            },
            {
                label: "土砂災害警戒区域（がけ崩れ）",
                type: "vector",
                id: "tosha_73_4",
                url:process.env.REACT_APP_LAYER_73_4,
                layerName: "73_kyukeisya_keikai",
                color:"#fffe9b",
                borderColor:"#72ac4d",
                opacity: 0.7,
                legendColorClass: "h-dosha-dsk-gake"
            },
            {
                label: "土砂災害特別警戒区域（がけ崩れ）",
                type: "vector",
                id: "73_kyukeisya_tokubetsukeikai",
                url:process.env.REACT_APP_LAYER_73_5,
                layerName: "73_kyukeisya_tokubetsukeikai",
                color:"#fe868d",
                borderColor:"#fc3dca",
                opacity: 0.7,
                legendColorClass: "h-dosha-dstk-gake"
            },
          
            {
                label: "土砂災害警戒区域（地すべり）",
                type: "vector",
                id: "tosha_73_3",
                url:process.env.REACT_APP_LAYER_73_3,
                layerName: "73_jisuberi_keikai",
                color:"#fffe9b",
                borderColor:"#eb7d3c",
                opacity: 0.7,
                legendColorClass: "h-dosha-dsk-jisuberi"
            },
        ]
    },

    {
        menuName: "住宅に関する情報",
        activateAccordion: false,
        useAccordion: true,
        layerOrderList : [
            {
                type: "element",
                id: "vis_98_35",
            },
            {
                type: "list",
                subLayerId: "vis_95_4",
                subLayerName: "推定空き家の分布",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_95_4",
                    },
                    {
                        type: "element",
                        id: "vis_95_5",
                    },
                    {
                        type: "element",
                        id: "vis_95_6",
                    },
                ],
            },
            {
                type: "element",
                id: "vis_95_7",
            },
        ],
        options: [
            {
                id: "vis_98_35",
                label: "不動産取引価格情報・成約価格情報",
                type: "geojson",
                fetchedServerKey: "XPT001",
                targetCode: "",
            },
            {
                label: "空き家件数（250mメッシュ）",
                type: "vector",
                id: "vis_95_4",
                url:process.env.REACT_APP_LAYER_95_4,
                layerName:"95_4_vacant_all_mesh",
                color:"#6373e6",
                borderColor:"#6373e6",
                opacity: 0.7,
            },
            {
                label: "空き家件数（町丁目）",
                type: "vector",
                id: "vis_95_5",
                url:process.env.REACT_APP_LAYER_95_5,
                layerName:"95_5_vacant_all_cho",
                color:"#6373e6",
                borderColor: "#808080",
                opacity: 0.7,
            },
            {
                label: "空き家率（町丁目）",
                type: "vector",
                id: "vis_95_6",
                url:process.env.REACT_APP_LAYER_95_6,
                layerName:"95_6_vacant_rate_cho",
                color:"#6373e6",
                borderColor: "#808080",
                opacity: 0.7,
            },
            {
                label: "マンションの管理状況の評価",
                type: "marker",
                id: "vis_95_7",
                column_lat: "Column91",
                column_lng: "Column92",
            },
        ]
    },
    {
        menuName: "都市計画法・建築基準法",
        activateAccordion: false,
        useAccordion: true,
        layerOrderList : [
            {
                type: "element",
                id: "vis_98_36",
            },
            {
                type: "list",
                subLayerId: "vis_98_37",
                subLayerName: "区域区分",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_98_37",
                    },
                    {
                        type: "element",
                        id: "vis_98_38",
                    },
                ]
            },
            {
                type: "list",
                subLayerId: "vis_98_39",
                subLayerName: "用途地域",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_98_39",
                    },
                    {
                        type: "element",
                        id: "vis_98_40",
                    },
                    {
                        type: "element",
                        id: "vis_98_41",
                    },
                    {
                        type: "element",
                        id: "vis_98_42",
                    },
                    {
                        type: "element",
                        id: "vis_98_43",
                    },
                    {
                        type: "element",
                        id: "vis_98_44",
                    },
                    {
                        type: "element",
                        id: "vis_98_45",
                    },
                    {
                        type: "element",
                        id: "vis_98_46",
                    },
                    {
                        type: "element",
                        id: "vis_98_47",
                    },
                    {
                        type: "element",
                        id: "vis_98_48",
                    },
                    {
                        type: "element",
                        id: "vis_98_49",
                    },
                    {
                        type: "element",
                        id: "vis_98_50",
                    },
                    {
                        type: "element",
                        id: "vis_98_51",
                    },
                ]
            },
            {
                type: "list",
                subLayerId: "vis_98_52",
                subLayerName: "防火・準防火地域",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_98_52",
                    },
                    {
                        type: "element",
                        id: "vis_98_53",
                    },
                ]
            },
            {
                type: "element",
                id: "vis_98_54",
            },
            {
                type: "element",
                id: "vis_98_55",
            },

            {
                type: "list",
                subLayerId: "vis_98_56",
                subLayerName: "立地適正化計画",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_98_56",
                    },
                    {
                        type: "element",
                        id: "vis_98_57",
                    },
                ]
            },

            {
                type: "element",
                id: "85_2_3_land_site",
            },
            {
                type: "element",
                id: "85_3_3_building_building",
            },
            {
                type: "element",
                id: "vis_96_1",
            },
            {
                type: "list",
                subLayerName: "指定道路図",
                subLayerList: [
                    {
                        type: "element",
                        id: "vis_93_1",
                    },
                    {
                        type: "element",
                        id: "vis_93_2",
                    },
                    {
                        type: "element",
                        id: "vis_93_3",
                    },
                ],
            },
        ],
        options: [
            {
                label: "土地利用現況（都市計画基礎調査）",
                type: "vector",
                id: "85_2_3_land_site",
                url:process.env.REACT_APP_LAYER_85_2_3_LAND_SITE,
                layerName:"85_2_3_land_site",
                color:"blue",
                opacity: 0.7,
                borderColor: "blue",
            },
            {
                label: "建物利用現況（都市計画基礎調査）",
                type: "vector",
                id: "85_3_3_building_building",
                url:process.env.REACT_APP_LAYER_85_3_3_BUILDING_BUILDING,
                layerName:"85_3_3_building_building",
                color:"blue",
                opacity: 0.7,
                borderColor: "blue",
            },
            {
                label: "都市計画区域",
                type: "vector",
                id: "vis_98_36",
                fetchedServerKey: "XKT001",
                url:process.env.REACT_APP_TILE_XKT001,
                layerName:"hits",
                color:"#969696",
                backgroundColor:"#ededed",
                opacity: 0.7,
                legendColorClass: "h-toshi-keikaku",
            },

            {
                label: "市街化区域",
                type: "vector",
                id: "vis_98_37",
                fetchedServerKey: "XKT001",
                url:process.env.REACT_APP_TILE_XKT001,
                layerName:"hits",
                color:"#ff3232",
                backgroundColor:"#ededed",
                opacity: 0.7,
                borderColor: "#f8b5e2",
                legendColorClass: "h-toshi-shigaika-kuiki",
            },

            {
                label: "市街化調整区域",
                type: "vector",
                id: "vis_98_38",
                fetchedServerKey: "XKT001",
                url:process.env.REACT_APP_TILE_XKT001,
                layerName:"hits",
                color:"#ffbeb4",
                backgroundColor:"#ededed",
                opacity: 0.7,
                borderColor: "#f6f0b8",
                legendColorClass: "h-vis_98_38",
            },

            {
                label: "第1種低層住居専用地域",
                type: "vector",
                id: "vis_98_39",
                fetchedServerKey: "XKT002",
                url:process.env.REACT_APP_TILE_XKT002,
                layerName:"hits",
                color:"#00B385",
                legendColorClass: "h-toshi-youto-01",
            },

            {
                label: "第2種低層住居専用地域",
                type: "vector",
                id: "vis_98_40",
                fetchedServerKey: "XKT002",
                url:process.env.REACT_APP_TILE_XKT002,
                layerName:"hits",
                color:"#7BD2B7",
                legendColorClass: "h-toshi-youto-02",
            },

            {
                label: "第1種中高層住居専用地域",
                type: "vector",
                id: "vis_98_41",
                fetchedServerKey: "XKT002",
                url:process.env.REACT_APP_TILE_XKT002,
                layerName:"hits",
                color:"#78CE3F",
                legendColorClass: "h-toshi-youto-03",
            },

            {
                label: "第2種中高層住居専用地域",
                type: "vector",
                id: "vis_98_42",
                fetchedServerKey: "XKT002",
                url:process.env.REACT_APP_TILE_XKT002,
                layerName:"hits",
                color:"#ADDF21",
                legendColorClass: "h-toshi-youto-04",
            },

            {
                label: "第1種住居地域",
                type: "vector",
                id: "vis_98_43",
                fetchedServerKey: "XKT002",
                url:process.env.REACT_APP_TILE_XKT002,
                layerName:"hits",
                color:"#EBEE5E",
                legendColorClass: "h-toshi-youto-05",
            },

            {
                label: "第2種住居地域",
                type: "vector",
                id: "vis_98_44",
                fetchedServerKey: "XKT002",
                url:process.env.REACT_APP_TILE_XKT002,
                layerName:"hits",
                color:"#FFD2B6",
                legendColorClass: "h-toshi-youto-06",
            },

            {
                label: "準住居地域",
                type: "vector",
                id: "vis_98_45",
                fetchedServerKey: "XKT002",
                url:process.env.REACT_APP_TILE_XKT002,
                layerName:"hits",
                color:"#FFA638",
                legendColorClass: "h-toshi-youto-07",
            },

            // {
            //     label: "田園住居地域",
            //     type: "vector",
            //     id: "vis_98_46",
            //     fetchedServerKey: "XKT002",
            //     url:process.env.REACT_APP_TILE_XKT002,
            //     layerName:"hits",
            //     color:"blue",
            //     opacity: 0.7,
            //     borderColor: "blue",
            // },

            {
                label: "近隣商業地域",
                type: "vector",
                id: "vis_98_47",
                fetchedServerKey: "XKT002",
                url:process.env.REACT_APP_TILE_XKT002,
                layerName:"hits",
                color:"#FFB0C3",
                legendColorClass: "h-toshi-youto-09",
            },

            {
                label: "商業地域",
                type: "vector",
                id: "vis_98_48",
                fetchedServerKey: "XKT002",
                url:process.env.REACT_APP_TILE_XKT002,
                layerName:"hits",
                color:"#FF593D",
                legendColorClass: "h-toshi-youto-10",
            },

            {
                label: "準工業地域",
                type: "vector",
                id: "vis_98_49",
                fetchedServerKey: "XKT002",
                url:process.env.REACT_APP_TILE_XKT002,
                layerName:"hits",
                color:"#A794C5",
                legendColorClass: "h-toshi-youto-11",
            },

            {
                label: "工業地域",
                type: "vector",
                id: "vis_98_50",
                fetchedServerKey: "XKT002",
                url:process.env.REACT_APP_TILE_XKT002,
                layerName:"hits",
                color:"#B9EAFF",
                legendColorClass: "h-toshi-youto-12",
            },

            {
                label: "工業専用地域",
                type: "vector",
                id: "vis_98_51",
                fetchedServerKey: "XKT002",
                url:process.env.REACT_APP_TILE_XKT002,
                layerName:"hits",
                color:"#0EC7FF",
                legendColorClass: "h-toshi-youto-13",
            },

            {
                label: "防火地域",
                type: "vector",
                id: "vis_98_52",
                fetchedServerKey: "XKT014",
                url:process.env.REACT_APP_TILE_XKT014,
                layerName:"hits",
                color:"#c50a0a",
                legendColorClass: "h-vis_98_52",
            },

            {
                label: "準防火地域",
                type: "vector",
                id: "vis_98_53",
                fetchedServerKey: "XKT014",
                url:process.env.REACT_APP_TILE_XKT014,
                layerName:"hits",
                color:"#ff6464",
                legendColorClass: "h-vis_98_53",
            },

            {
                label: "高度利用地区",
                type: "vector",
                id: "vis_98_54",
                fetchedServerKey: "XKT024",
                url:process.env.REACT_APP_TILE_XKT024,
                layerName:"hits",
                color:"#ffc73f",
                legendColorClass: "h-vis_98_54",
            },
          
            {
                label: "地区計画",
                type: "vector",
                id: "vis_98_55",
                fetchedServerKey: "XKT023",
                url:process.env.REACT_APP_TILE_XKT023,
                layerName:"hits",
                color:"#dd1313",
                legendColorClass: "h-vis_98_55",
            },

            {
                label: "居住誘導区域",
                type: "vector",
                id: "vis_98_56",
                fetchedServerKey: "XKT003",
                url:process.env.REACT_APP_TILE_XKT003,
                layerName:"hits",
                color:"#2121e0",
                legendColorClass: "h-vis_98_56",
            },

            {
                label: "都市機能誘導区域",
                type: "vector",
                id: "vis_98_57",
                fetchedServerKey: "XKT003",
                url:process.env.REACT_APP_TILE_XKT003,
                layerName:"hits",
                color:"#ff1111",
                legendColorClass: "h-vis_98_57",
            },

            {
                id: "vis_96_1",
                label: "建物利用現況（都市計画基礎調査【補足】確認済証番号）",
                type: "marker",
                column_lat: "座標値(Y)",
                column_lng: "座標値(X)",
            },
            {
                label: "第42条第1項第4号",
                type: "vector",
                id: "vis_93_1",
                url:process.env.REACT_APP_LAYER_93_1,
                layerName:"93_1_shitei_douro_4214",
                color:"purple",
                opacity: 0.7,
                borderColor: "#ff7000",
                legendColorClass: "h-kenchikukijyun-42-1-4"
            },
            {
                label: "第42条第1項第5号",
                type: "vector",
                id: "vis_93_2",
                url:process.env.REACT_APP_LAYER_93_2,
                layerName:"93_2_shitei_douro_4215",
                color:"green",
                opacity: 0.7,
                borderColor: "#fcb000",
                legendColorClass: "h-kenchikukijyun-42-1-5"
            },
            {
                label: "第42条第２項",
                type: "vector",
                id: "vis_93_3",
                url:process.env.REACT_APP_LAYER_93_3,
                layerName:"93_3_shitei_douro_422",
                color:"blue",
                opacity: 0.7,
                borderColor: "#61DBFF",
                legendColorClass: "h-kenchikukijyun-42-2"
            },
        ]
    }
];

export  {
    kashika5Options
};
